import React from "react";

interface Props {
  onClick?: () => void;
}

function AboutButton(props: Props) {
  return (
    <div className="flex items-center justify-center flex-col">
      <button
        id="about-cta-button"
        onClick={props.onClick}
        className={`w-[70%] max-w-[320px] rounded-full font-medium mt-10 px-8 py-2.5 text-white dark:text-black transition-colors duration-300 transform bg-black dark:bg-white hover:bg-gray-600 focus:outline-hidden focus:bg-gray-600`}
      >
        {"Your journey starts here"}
      </button>
    </div>
  );
}

export default AboutButton;
